'use strict';

module.exports = {
    scrollToId: function() {
        // scroll to other elements on page
        $('.rc-scrollable-buttons li a').on('click', function (e){
            if ( $(this).attr('data-btntype') === 'scroll' ) {
                var offset = 20;
                if( $(window).width() >= 544 ) {
                    offset = 160;                   // to make up for nav overlay
                }
                var elementId = $(this).attr('data-scrollid');
                e.preventDefault();
                $("html, body").animate({ 
                    scrollTop: $(elementId).offset().top - offset
                }, 500);
            }
        });
    }
}
